import { useTranslation } from 'react-i18next';
import { Navigate, useParams } from 'react-router-dom';

import { AnimatedRoutedDrawer } from 'src/Components/Drawers/AnimatedRoutedDrawer';
import { ChecklistEditionFormWrapper } from 'src/Components/Forms/Checklist/ChecklistEditionFormWrapper';

type ChecklistParams = {
  checklistId: string;
};

const EditChecklistDrawer = () => {
  const { t } = useTranslation();
  const { assetId, checklistId } = useParams<{ assetId: string } & ChecklistParams>();

  if (!checklistId) {
    return <Navigate to="/" replace />;
  }

  return (
    <AnimatedRoutedDrawer
      title={t('checklist.editForm.editChecklist', 'Modifier la checklist')}
      to={`/asset/${assetId}/guides/checklists`}
    >
      {({ onClose }) => (
        <ChecklistEditionFormWrapper
          onCreate={onClose}
          onCancel={onClose}
          checklistId={checklistId}
        />
      )}
    </AnimatedRoutedDrawer>
  );
};

export default EditChecklistDrawer;
